<div class="lm-genai-prompt-div">
  <div class="lm-genai-prompt-prompt-div">
      <div class="lm-genai-original-text">
          <label
              class="lm-genai-prompt-label"
              soho-label
              [required]="true"
              for="lm-genai-input"
          >{{ isRephraseMode ? ('GenAIOriginalText' | translate) : ('KeyPointsLabel' | translate) }}</label>
          <textarea
              name="lm-genai-input"
              id="lm-genai-input"
              data-automation-id="lm-genai-input"
              soho-textarea
              placeholder="{{ 'GenAIPlaceholderText' | translate }}"
              class="lm-genai-prompt-textarea"

              [disabled]="isGenerating"
              attr.data-validate="required"
              [(ngModel)]="genAIPrompt.value"
              attr.aria-label="{{ isRephraseMode ? ('GenAIOriginalText' | translate) : ('KeyPointsLabel' | translate) }}">
          </textarea>
      </div>

    @if(isRephraseMode) {
      <div class="lm-genai-rephrase">
          <div class="field">
              <label soho-label for="lm-genai-change-length">{{'GenAIChangeLength' | translate}}</label>
              <select soho-dropdown id="lm-genai-change-length" [(ngModel)]="genAIPrompt.changeLength"
                      data-automation-id="lm-genai-change-length"
                      name="lm-genai-change-length"
                      noSearch class="dropdown-md">
                  <option [value]="''">{{''}}</option>
                  <option [value]="'lengthen'">{{'GenAILengthen' | translate}}</option>
                  <option [value]="'shorten'">{{'GenAIShorten' | translate}}</option>
              </select>
          </div>
          <div class="field">
              <label soho-label for="lm-genai-change-tone">{{'GenAIChangeTone' | translate}}</label>
              <select soho-dropdown id="lm-genai-change-tone" [(ngModel)]="genAIPrompt.changeTone"
                      data-automation-id="lm-genai-change-tone"
                      name="lm-genai-change-tone"
                      noSearch class="dropdown-md">
                  <option [value]="''">{{''}}</option>
                  <option [value]="'professional'">{{'GenAIProfessional' | translate}}</option>
                  <option [value]="'formal'">{{'GenAIFormal' | translate}}</option>
                  <option [value]="'casual'">{{'GenAICasual' | translate}}</option>
              </select>
          </div>
      </div>
    }

    <button #generateButton
      data-automation-id="lm-genai-button"
      class="btn-primary btn-generative lm-genai-prompt-button"
      [disabled]="genAIPrompt.value.length === 0 || isGenerating"
      (click)="onGenerateClickEvent($event)"
      >{{ isRephraseMode ? ('GenAIRephrase' | translate) : ('GenerateAIButton' | translate) }}
    </button>
  </div>
  <div class="editor-container is-readonly lm-genai-prompt-editor-container">
    @if (isGeneratedError) {
      <div id="generated-error" class="error-message" style="font-size:14px; max-width:500px" data-automation-id="lm-genai-prompt-generated-alert">
        <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-error"></use>
        </svg>
        <pre class="audible">{{generatedErrorMessage}}</pre>
        <p class="message-text">{{generatedErrorMessage}}</p>
      </div>
    }
    <label
      class="lm-genai-prompt-label"
      soho-label
      for="lm-genai-text"
    >{{ 'GeneratedAITextLabel' | translate }}</label>
    <div
      name="lm-genai-text"
        id="lm-genai-text"
        data-automation-id="lm-genai-text"
      soho-editor
      disabled="true"
      class="lm-genai-prompt-editor"
      soho-alert

      [(ngModel)]="genAIResponse.value"
      attr.aria-label="{{ 'GenAI' | translate }}">
    </div>
    <div id="disclaimer" class="tag-container">
      <span lm-field-style class="tag" style="height: auto;">{{disclaimerMessage}}</span>
    </div>
  </div>
</div>
